export default {
    list: {
        orderId: 'Номер заказа',
        pfm: 'Код магазина ПФМ',
        dateCreate: 'Дата создания',
        orderStatus: 'Статус обработки',
        deliveryServiceType: 'Тип доставки',
        payType: 'Тип оплаты',
        orderSourceType: 'Источник заказа',
        userAuthorization: 'Статус пользователя',
        name: 'ФИО',
        email: 'Почта',
        accuracy: 'Точность заказа',
        orderInfo: 'Информация по заказу',
        integrity: 'Целостность заказа',
        equipment: 'Комплектация заказа',
        comment: 'Комментарий',
        rating: 'Оценка',
    },
    filter: {
        deliveryServiceTypes: {
            placeholder: 'Тип доставки',
            text: 'Выбрано типов доставки',
        },
        payTypes: {
            placeholder: 'Тип оплаты',
            text: 'Выбрано типов оплаты',
        },
        orderSourceTypes: {
            placeholder: 'Источник заказа',
            text: 'Выбрано источников заказа',
        },
        userAuthorization: {
            placeholder: 'Статус пользователя',
            text: 'Выбрано статусов пользователя',
        },
        rating: {
            placeholder: 'Оценка',
            text: 'Выбрано оценок',
        },
        dateCreateFrom: 'Дата создания: от',
        dateCreateTo: 'Дата создания: до',
        orderId: 'Номер заказа',
        pfm: 'Код магазина ПФМ',
        language: 'Язык',
    },
    catalog: {
        'boolean': {
            yes: 'Да',
            no: 'Нет',
        },
    },
    questions: {
        pickUp: {
            text: 'Вопрос для самовывоза',
            accuracy: 'Дүкен қызметкерлері тапсырысты 15 минут ішінде жинады ма?', // Сотрудники магазина собрали заказ в течение 15 минут?
            orderInfo: 'Сізге тапсырыстың дайындығы туралы SMS келді ме?', // Приходило ли Вам смс о готовности заказа?
            // eslint-disable-next-line max-len
            integrity: 'Тапсырыс бойынша жиналған тауарлардың күйі көңіліңізден шықты ма?', // Соответствует ли состояние товаров Вашим ожиданиям?
            equipment: 'Тапсырыс дұрыс жиналды ма?', // Заказ был скомплектован правильно?
            rating: 'Сіздің соңғы тапсырыңыз қалай өтті?', // Как прошел Ваш последний заказ?
        },
        delivery: {
            text: 'Вопрос для доставки',
            accuracy: 'Тапсырысыңызды таңдалған күні алдыңыз ба?', // Вы получили заказ в выбранную дату?
            orderInfo: 'Сізге тапсырыс туралы ақпарат бар см?', // Вам пришло смс c информацией о заказе?
            // eslint-disable-next-line max-len
            integrity: 'Тапсырыс бойынша жиналған тауарлардың күйі көңіліңізден шықты ма?', // Соответствует ли состояние товаров Вашим ожиданиям?
            equipment: 'Тапсырыс дұрыс жиналды ма?', // Заказ был скомплектован правильно?
            rating: 'Сіздің соңғы тапсырыңыз қалай өтті?', // Как прошел Ваш последний заказ?
        },
    },
};